
import React from 'react';

import OperationItem from './OperationItem.state';
import OperationItemListView from './OperationItemList.view';

const OperationItemList = ({
    operation,
    operationItems,
    readOnly
}) => {

    const handleRenderOperationItem = (operationItem) => {
        return (
            <OperationItem
                key={operationItem.id}
                operation={operation}
                operationItem={operationItem}
                readOnly={readOnly}
            />
        );
    }

    return (
        <OperationItemListView
            operationItems={operationItems}
            onRenderOperationItem={handleRenderOperationItem}
        />
    );
}

export default OperationItemList;
